(function ($) {
  $(document).ready(function () {
    // Home Slideshow
    $(window).scroll(function () {
      if ($('[data-slide-fixed]').length) {
        var sliderScroll = $(window).scrollTop(),
          windowHeight = $(window).outerHeight();

        if (sliderScroll >= (windowHeight * 1.5)) {
          $('[data-slide-fixed]').addClass('slideshow-fixed');
        } else {
          $('[data-slide-fixed]').removeClass('slideshow-fixed');
        }
      }
    });

    // Featured Collections
    featuredCollections(0);
    function featuredCollections(c) {
      setTimeout(() => {
        if ($('.relitems__swiper').length) {
          const linksSwiper = document.querySelectorAll('.relitems__swiper');
          if (linksSwiper) {
            let ls_arr = [];
            let sliderNo = 1;
            linksSwiper.forEach(linksSwiper => {
              const parent = linksSwiper.closest('.relitems');
              if (parent) parent.classList.add('ls_parent_' + sliderNo);
              linksSwiper.classList.add('ls_' + sliderNo);

              let dragSize = $(this).data('drag-size') ? $(this).data('drag-size') : 50;

              const swiperItem = new Swiper('.ls_' + sliderNo, {
                slidesPerView: 'auto',
                spaceBetween: 0,
                loop: false,
                grabCursor: true,
                threshold: 25,
                navigation: {
                  nextEl: '.ls_parent_' + sliderNo + ' .swiper-button-next',
                  prevEl: '.ls_parent_' + sliderNo + ' .swiper-button-prev',
                },
                scrollbar: {
                  el: '.ls_parent_' + sliderNo + ' .swiper-scrollbar',
                  draggable: true,
                  dragSize: 98,
                  // snapOnRelease: true
                },
                breakpoints: {
                  0: {
                    slidesPerView: 1,
                    spaceBetween: 0
                  },
                  640: {
                    slidesPerView: 2,
                    spaceBetween: 0
                  },
                  1025: {
                    slidesPerView: 3,
                    spaceBetween: 0
                  },
                  1920: {
                    slidesPerView: 3,
                    spaceBetween: 0
                  },
                  1921: {
                    slidesPerView: 3,
                    spaceBetween: 0
                  }
                }
              });
              swiperItem.update();
              swiperItem.updateProgress()
              swiperItem.updateSize()
              swiperItem.updateSlides()
              sliderNo++;
            });
          }

          // Product postion nav
          if ($('.relitems__swiper .product-card__figure').length) {
            const heightImageProduct = () => {
              var heightItemProduct = $('.relitems__swiper .product-card__figure').outerHeight();
              // setProperty for all items instead of just 1 item
              const homeProductList = document.querySelectorAll('.relitems__swiper');
              const homeProductListArr = [...homeProductList];
              homeProductListArr.forEach(item => {
                item.style.setProperty('--button-nav-position', heightItemProduct / 2 + 'px');
              });
            }
            window.addEventListener('resize', heightImageProduct);
            heightImageProduct();
          }

          $(document).on('hover', 'product-recommendations .product-card', function () {
            const slideVideo = $(this).get(0).querySelector('video')
            const iframeWrap = $(this).get(0).querySelector('.iframe_wrap');
            const iframe = iframeWrap ? iframeWrap.getAttribute('data-video') : '';
            if (slideVideo) slideVideo.play();

            if (iframeWrap) {
              if (null == iframeWrap.querySelector('iframe')) {
                iframeWrap.innerHTML = '';
                iframeWrap.insertAdjacentHTML('beforeend', iframe);
                if (iframeWrap.querySelector('iframe'))
                  iframeWrap.querySelector('iframe').src = iframeWrap.querySelector('iframe').src + '&autoplay=1';
              }
            }
          });
          $(document).on('mouseleave', 'product-recommendations .product-card', function () {
            const slideVideo = $(this).get(0).querySelector('video');
            const iframeWrap = $(this).get(0).querySelector('.iframe_wrap');
            const iframe = iframeWrap ? iframeWrap.getAttribute('data-video') : '';
            if (slideVideo) slideVideo.pause();
            if (iframeWrap) {
              setTimeout(function () {
                iframeWrap.innerHTML = '';
              }, 200);
            }
          });
        } else {
          featuredCollections(c + 1)
        };
      }, 1000);
    }

    const slide_swiper = document.querySelectorAll('.slide_swiper');
    if (slide_swiper.length) {
      slide_swiper.forEach((single_swiper) => {
        const slide_time = single_swiper.getAttribute('data-slide_time') ? parseInt(single_swiper.getAttribute('data-slide_time')) * 1000 : 10000;
        single_swiper.style.setProperty('--slide-anim-time', `${slide_time / 1000}s`);
        const swiper = new Swiper(single_swiper, {
          loop: true,
          watchSlidesProgress: false,
          autoplayDisableOnInteraction: false,
          grabCursor: false,
          slidesPerView: 1,
          noSwiping: true,
          spaceBetween: 5,
          autoplay: {
            delay: slide_time, //animation
            disableOnInteraction: false,
            pauseOnMouseEnter: false
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          pagination: {
            el: '.slide_swiper .swiper-pagination',
            clickable: true,
            type: 'bullets',
            renderBullet: function (index, className) {
              return '<span class="' + className + '">' + '<i></i>' + '<b></b>' + '</span>';
            },
          },
          on: {
            init: function (swiper) {
              const firstSlide = swiper.slides[0];
              if (firstSlide) {
                const slideVideo = firstSlide.querySelector('video');

                if (slideVideo && !slideVideo.getAttribute('data-loaded')) {
                  slideVideo.load();
                  slideVideo.setAttribute('data-loaded', true);
                  slideVideo.play();
                }
              }

            },
            slideChange: function () {
              const swiper = this;

              for (const bullet of swiper.pagination.bullets) {
                bullet.classList.remove('active');
              }

              for (const bullet of swiper.pagination.bullets) {
                if (bullet.classList.contains('swiper-pagination-bullet-active')) {
                  break;
                }
                bullet.classList.add('active');
              }

              this.slides.forEach(function (elem, key) {
                const slideVideo = elem.querySelectorAll('video');
                slideVideo.forEach(function (item, index) {
                  if (item && !item.getAttribute('data-loaded')) {
                    item.load();
                    item.setAttribute('data-loaded', true);
                  }
                  if (key == swiper.activeIndex) {
                    if (item) item.play();
                  } else {
                    if (item) item.pause();
                  }
                });
              });
              swiper.autoplay.start();
            }
          }
        });

        if (document.querySelector('.homepage_page')) {
          swiper.autoplay.stop();
          setTimeout(() => {
            swiper.autoplay.start();
            for (const bullet of swiper.pagination.bullets) {
              bullet.querySelector('b').style.animationPlayState = 'running';
            }
          }, 6500);
        }
      });
    }

    // Blog slider homepage
    if ($('.article__swiper .ArticleItem__ImageWrapper').length) {
      const heightImageBlog = () => {
        var heightItemBlog = $('.article__swiper .ArticleItem__ImageWrapper').outerHeight();
        const homeBlogList = document.querySelector('.article__swiper');
        homeBlogList.style.setProperty('--button-nav-position', heightItemBlog / 2 + 'px');
      }
      window.addEventListener('resize', heightImageBlog);
      heightImageBlog();
    }
    if ($('.article__swiper_custom .ArticleItem__ImageWrapper').length) {
      const heightImageBlog = () => {
        var heightItemBlogCustom = $('.article__swiper_custom .ArticleItem__ImageWrapper').outerHeight();
        const homeBlogListCustom = document.querySelector('.article__swiper_custom');
        homeBlogListCustom.style.setProperty('--button-nav-position', heightItemBlogCustom / 2 + 'px');
      }
      window.addEventListener('resize', heightImageBlog);
      heightImageBlog();
    }

    // Subscriptions
    if ($('.homepage_subscriptions_wrap')) {
      $('.single_homepage_subscriptions_header').click(function () {
        $(this).toggleClass('active');
        $(this).next('.single_homepage_subscriptions_content').slideToggle().toggleClass('active');
        $(this).parent('.single_homepage_subscriptions_filter').siblings('.single_homepage_subscriptions_filter').find('.single_homepage_subscriptions_header').removeClass('active');
        $(this).parent('.single_homepage_subscriptions_filter').siblings('.single_homepage_subscriptions_filter').find('.single_homepage_subscriptions_content').slideUp().removeClass('active');
      });

      // Subscriptions choose options:
      $('.single_homepage_subscriptions_list .single_filter').on("click", function (evt) {
        var headerQuestion = $(this).find('.checkbox_text').text();
        var dataWeight = parseInt($(this).attr('data-weight'));

        $(this).parents('.single_homepage_subscriptions_filter').addClass('added')
        $(this).parents('.single_homepage_subscriptions_filter').attr('data-weight-item', dataWeight);
        $(this).parents('.single_homepage_subscriptions_filter').find('.header_question').text(headerQuestion).show();
        $(this).parents('.single_homepage_subscriptions_filter').find('.header_label').hide();

        var allSameClass = true;
        var targetClass = 'added';

        $('.single_homepage_subscriptions_filter').each(function () {
          if (!$(this).hasClass(targetClass)) {
            allSameClass = false;
            return false; // Exit the loop early if a different class is found
          }
        });

        if (allSameClass) {
          $('.homepage_subscriptions_button').show();
        } else {

        }
      });

      // Subscriptions clear options checked
      $('.homepage_subscriptions_button .button_clear').on("click", function (evt) {
        $(".single_homepage_subscriptions_filter input").prop('checked', false);
        $('.homepage_subscriptions_filters_list').attr('data-weight-total', '0');
        $('.single_homepage_subscriptions_filter').attr('data-weight-item', '0').removeClass('added');
        $('.homepage_subscriptions_button').hide();

        $('.single_homepage_subscriptions_header .header_question').hide();
        $('.single_homepage_subscriptions_header .header_label').show();
      })

      // Subscriptions back
      $('.homepage_subscriptions_button_back .button_back').click(function () {
        // $(".single_homepage_subscriptions_filter input").prop('checked', false);
        $('.homepage_subscriptions_filters_list').show();
        // $('.homepage_subscriptions_filters_list').attr('data-weight-total', '0').show();
        // $('.single_homepage_subscriptions_filter').attr('data-weight-item', '0').removeClass('added');
        $('.homepage_subscriptions_result_items').hide();
        $('.homepage_subscriptions_button').show();

        // $('.single_homepage_subscriptions_header .header_question').hide();
        // $('.single_homepage_subscriptions_header .header_label').show();
      })

      // Subscriptions submit
      $('.homepage_subscriptions_button .button_submit').on("click", function (evt) {
        var dataWeightResult = parseInt($('.homepage_subscriptions_filters_list').attr('data-weight-result'));
        var dataWeightTotal = 0;
        $('.single_homepage_subscriptions_filter').each(function () {
          var dataWeightItem = parseInt($(this).attr('data-weight-item'));
          dataWeightTotal = parseInt(dataWeightTotal + parseInt(dataWeightItem));
        })
        $('.homepage_subscriptions_filters_list').attr('data-weight-total', dataWeightTotal);
        $('.homepage_subscriptions_finding').show();
        $('.homepage_subscriptions_filters_list').hide();
        $('.homepage_subscriptions_button').hide();
        setTimeout(function () {
          $('.homepage_subscriptions_finding').hide();
        }, 1000);
        setTimeout(function () {
          $('.homepage_subscriptions_result_items').show();
          if (dataWeightTotal > dataWeightResult) {
            $('.homepage_subscriptions_result_cs').show();
            $('.homepage_subscriptions_result_tec').hide();
          } else {
            $('.homepage_subscriptions_result_tec').show();
            $('.homepage_subscriptions_result_cs').hide();
          }
        }, 1000);
      });
    }


    // Footer
    $(".Footer__Menu .Footer__Block_mobile .Linklist").hide();
    $(".Footer__Menu .Footer__Block_mobile ").click(function () {
      $(this).find('.Footer__Title').next().stop().slideToggle(".Linklist");
      $(this).toggleClass("active");
    });

    if (navigator.userAgent.indexOf('Mac OS X') != -1) {
      $("body").addClass("mac");
    } else {
      $("body").addClass("pc");
    }

    /**
     * email validation
     */
    function validateEmail(email) {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return re.test(email);
    }

    const emailInput = document.getElementById("email");
    const submitButton = document.getElementById("submit_nws");
    const $result = $('#result');
    $result.text('');
    if (submitButton) {
      submitButton.addEventListener("click", function (event) {
        event.preventDefault(); // zatrzymaj domyślne zachowanie przycisku submit

        const email = emailInput.value;

        if (validateEmail(email)) {
          const body = new URLSearchParams({})
          body.append('a', `${ window.theme.klaviyo_public_key }`)
          body.append('g', `${ window.theme.klaviyo_list_newsletter_subscribers_id }`)
          body.append("email", email)
          body.append("$source", "Newsletter")

          const options = {
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              Accept: 'application/json',
              'cache-control': 'no-cache',
            },
            body,
          };

          fetch('https://a.klaviyo.com/ajax/subscriptions/subscribe', options)
            .then(response => {
              $('#footer-newsletter .form_btns').hide();
              $('#footer-newsletter').append('<p class="Form__Alert Alert Alert--success">Thank you for signing up!</p>');
            })
            .catch(err => console.error(err));

        } else {
          $result.text('Please enter a valid email address');
          $result.css('color', 'red');
        }
      });
    }


    /**
     * popup dropdown
     */
    $(document).on("click", ".quick-buy-modal__content x-popover.popover .popover__value-list button", function () {
      $(this).parents('x-popover').removeAttr('open').css({ 'display': 'none', 'opacity': '0' }).siblings('button.select').attr('aria-expanded', false);
    });

    /**
    * Cookies
    */
    function getCookie(name) {
      var cname = name + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(cname) == 0) {
          return c.substring(cname.length, c.length);
        }
      }
      return "";
    }
    var cookies = getCookie("cookie_closed");
    if (cookies != "true") {
      $('privacy-banner.privacy-banner').fadeIn();
      $('privacy-banner.privacy-banner').addClass("active_cookie");
    }

    $('privacy-banner.privacy-banner').on('click', '.pop-in__close-button, button[data-action="accept"]', function () {
      $('privacy-banner.privacy-banner').fadeOut();
      $('privacy-banner.privacy-banner').removeClass("active_cookie");
      setCookie('cookie_closed', 'true', 1000);
    });

    function setCookie(cName, cValue, expDays) {
      let date = new Date();
      date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));
      const expires = "expires=" + date.toUTCString();
      document.cookie = cName + "=" + cValue + "; " + expires + "; path=/";
    }

    /**
     * End Cookies
     */
  });
})(jQuery);